import { kngApi } from 'yxt-biz-pc/packages/api';

// 获取知识新目录树
export const getKngTreeNew = (body)=>kngApi.post('kngCatalog/tree', body);
